import { createContext, useState, useContext, useEffect, useRef } from "react";
import clockIcon from "../assets/clock-icon.svg";
import goodIcon from "../assets/good-icon.svg";

export const Context = createContext();

export const ContextProvider = ({ children }) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  const [selectedDate, setSelectedDate] = useState({ date: new Date(), isSelected: false });
  const [selectedTime, setSelectedTime] = useState({
    from: { hour: 0, minets: 0 },
    to: { hour: 0, minets: 0 },
  });
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [place, setPlace] = useState(null);
  const [distance, setDistance] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");
  const [gender, setGender] = useState("");
  const [qualification, setQualification] = useState("");
  const [answerTo, setAnswerTo] = useState({
    date: { days: 0, months: 0 },
    time: { hour: 0, minets: 0 },
  });
  const [filledCards, setFilledCards] = useState([]);
  
  // Generate random working days (Monday-Friday) for current month
  const getRandomWorkingDays = (year, month, count = 3) => {
    const workingDays = [];
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const dayOfWeek = date.getDay();
      // 1-5 represents Monday-Friday (Sunday is 0, Saturday is 6)
      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        workingDays.push(day);
      }
    }
    
    // Randomly select 'count' days from working days
    const selectedDays = [];
    const availableDays = [...workingDays];
    
    /*for (let i = 0; i < Math.min(count, availableDays.length); i++) {
      const randomIndex = Math.floor(Math.random() * availableDays.length);
      selectedDays.push(availableDays[randomIndex]);
      availableDays.splice(randomIndex, 1);
    }*/
	selectedDays.push(availableDays[1], availableDays[8], availableDays[10]);
    
    return selectedDays.sort((a, b) => a - b);
  };
  
  const [day1, day2, day3] = getRandomWorkingDays(currentYear, currentMonth, 3);
  const [orders, setOrders] = useState([
    {
      id: "099 000 000 00",
      date: new Date(currentYear, currentMonth, day3),
      status: "pending",
    },
    {
      id: "099 000 000 00",
      date: new Date(currentYear, currentMonth, day3),
      status: "completed",
    },
    {
      id: "099 000 000 00",
      date: new Date(currentYear, currentMonth, day3),
      status: "completed",
    },
    {
      id: "099 000 000 00",
      date: new Date(currentYear, currentMonth, day3),
      status: "completed",
    },
    {
      id: "099 000 000 00",
      date: new Date(currentYear, currentMonth, day1),
      status: "completed",
    },
    {
      id: "099 000 000 00",
      date: new Date(currentYear, currentMonth, day2),
      status: "pending",
    },
  ]);

  const resetFormState = () => {
    setSelectedDate({ date: new Date(), isSelected: false });
    setSelectedTime({ from: { hour: 0, minets: 0 }, to: { hour: 0, minets: 0 } });
    setSelectedLanguage("");
    setPlace(null);
    setDistance("");
    setHourlyRate("");
    setGender("");
    setQualification("");
    setAnswerTo({
      date: { days: 0, months: 0 },
      time: { hour: 0, minets: 0 },
    });
    setFilledCards([]);
  };

  const formatWithLeadingZero = (value) => (value < 10 ? `0${value}` : value);

  const prevTimeRef = useRef(selectedTime);
  const prevAnswerRef = useRef(answerTo);

  useEffect(() => {
    if (
      prevTimeRef.current.from.hour !== selectedTime.from.hour ||
      prevTimeRef.current.from.minets !== selectedTime.from.minets ||
      prevTimeRef.current.to.hour !== selectedTime.to.hour ||
      prevTimeRef.current.to.minets !== selectedTime.to.minets
    ) {
      prevTimeRef.current = selectedTime;

      const timeCard = {
        content: `${formatWithLeadingZero(selectedTime.from.hour)}.${formatWithLeadingZero(
          selectedTime.from.minets
        )} - ${formatWithLeadingZero(selectedTime.to.hour)}.${formatWithLeadingZero(selectedTime.to.minets)}`,
        isSelected: true,
        title: "Time",
        icon: clockIcon,
      };

      setFilledCards((prev) => {
        const existingIndex = prev.findIndex((card) => card.title === "Time");
        if (existingIndex !== -1) {
          const updatedCards = [...prev];
          updatedCards[existingIndex] = timeCard;
          return updatedCards;
        }
        return [...prev, timeCard];
      });
    }
  }, [selectedTime]);

  useEffect(() => {
    if (
      prevAnswerRef.current.date.days !== answerTo.date.days ||
      prevAnswerRef.current.date.months !== answerTo.date.months ||
      prevAnswerRef.current.time.hour !== answerTo.time.hour ||
      prevAnswerRef.current.time.minets !== answerTo.time.minets
    ) {
      prevAnswerRef.current = answerTo;

      const answerCard = {
        content: `${formatWithLeadingZero(answerTo.date.days)}.${formatWithLeadingZero(
          answerTo.date.months
        )} / ${formatWithLeadingZero(answerTo.time.hour)}.${formatWithLeadingZero(answerTo.time.minets)}`,
        isSelected: true,
        title: "Antwort bis",
        icon: goodIcon,
      };

      setFilledCards((prev) => {
        const existingIndex = prev.findIndex((card) => card.title === "Antwort bis");
        if (existingIndex !== -1) {
          const updatedCards = [...prev];
          updatedCards[existingIndex] = answerCard;
          return updatedCards;
        }
        return [...prev, answerCard];
      });
    }
  }, [answerTo]);

  return (
    <Context.Provider
      value={{
        selectedDate,
        setSelectedDate,
        selectedTime,
        setSelectedTime,
        selectedLanguage,
        setSelectedLanguage,
        place,
        setPlace,
        distance,
        setDistance,
        hourlyRate,
        setHourlyRate,
        gender,
        setGender,
        qualification,
        setQualification,
        answerTo,
        setAnswerTo,
        filledCards,
        setFilledCards,
        orders,
        setOrders,
        resetFormState,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const useContextValue = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error("useContextValue must be used within a ContextProvider");
  }
  return context;
};
